export default __webpack_public_path__ + "static/media/home-active.003d73c6.svg";